angular.module('BB').directive('bbInclude', ($compile) => {
        return {
            link(scope, element, attr) {
                return scope.$watch('bb.path_setup', (newval, oldval) => {
                        if (newval) {

                            element.attr('ng-include', `'${scope.getPartial(attr.bbInclude)}'`);
                            element.attr('bb-include', null);
                            $compile(element)(scope);
                        }
                    }
                );
            }
        };
    }
);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_helpers/bb_include.directive.js